import { Box } from '@chakra-ui/react';

export const StyledDivider = () => (
  <Box
    display={{ base: 'none', md: 'block' }}
    width="2px"
    height="16px"
    background="chakra-border-color"
    borderRadius="100px"
    ml="12px"
    mr="12px"
    flexShrink={0}
  />
);
